import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { Reveal, SectionHeading, EASE } from "@/components/Reveal";

const IMG = "/images/concept-patek.jpg";

const POINTS = [
  {
    title: "Vous validez d'abord la proposition",
    text: "BABYLON fonctionne sur un modèle de recherche et d'acquisition personnalisée. Aucun paiement n'est demandé avant que vous ayez reçu et validé une proposition détaillée.",
  },
  {
    title: "Un acompte peut sécuriser l'acquisition",
    text: "Selon les conditions de la transaction, un paiement ou un acompte peut être demandé afin de sécuriser l'acquisition et nous permettre de procéder auprès du fournisseur.",
  },
  {
    title: "Des modalités communiquées en toute transparence",
    text: "Les modalités de paiement vous sont toujours communiquées clairement avant toute validation. Vous savez exactement ce que vous achetez, à quel prix et dans quelles conditions.",
  },
];

export default function Payment() {
  return (
    <section id="paiement" className="relative py-32 lg:py-48 overflow-x-clip" data-testid="payment-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-3 border border-gold/15 translate-x-3 -translate-y-3 pointer-events-none" />
              <div className="overflow-hidden gold-frame">
                <motion.img
                  src={IMG}
                  alt="Patek Philippe — fond de boîte, sceau de la manufacture genevoise"
                  className="w-full h-[340px] sm:h-[460px] object-cover object-[center_30%]"
                  whileHover={{ scale: 1.04 }}
                  transition={{ duration: 1.2, ease: EASE }}
                  data-testid="payment-image"
                />
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <SectionHeading
            eyebrow="Transparence"
            title={
              <>
                Comment se passe
                <br />
                <span className="italic text-gold">le paiement ?</span>
              </>
            }
          />
          <div className="mt-12 space-y-9">
            {POINTS.map((p, i) => (
              <Reveal key={p.title} delay={0.12 * i}>
                <div className="flex gap-5" data-testid={`payment-point-${i}`}>
                  <CheckCircle2 size={20} strokeWidth={1.3} className="text-gold shrink-0 mt-1" />
                  <div>
                    <h3 className="font-display text-xl sm:text-2xl text-ivory">{p.title}</h3>
                    <p className="mt-3 text-sm sm:text-base text-stone2 leading-relaxed max-w-xl">{p.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
